import {
    SHOW_VARIANT_TYPE_SLIDER,
    SHOW_VARIANT_OPTIONS_SLIDER,
    SHOW_EDIT_VARIANT_SLIDER,
    SET_VARIANT_DATA,
    SHOW_VARIANT_DETAILS_SLIDER,
    SET_VARIANT_COMBINATIONS,
    SET_VARIANT_PRODUCT_DATA,
    SET_VARIANT_CORRECTION,
    SHOW_MORE_DETAILS_SLIDER,
    RESET_VARIANT_DATA,
    SET_SYNC_IMAGES,
    SHOW_SYNC_IMAGES_MODAL,
    SHOW_SETTINGS_SLIDER,
    SET_EDIT_VARIANT_DATA,
    UPDATE_VARIANT_SPEC
} from '../actions/types'; 

const initialState = {
    variantData: [],
    variantCombinations: [],
    variantProductData: [],
    variantCorrection: {},
    showEditVariantSlider: false,
    variantTypeSlider: {
        show: false,
        mode: 'add'
    },
    variantOptionsSlider: {
        show: false,
        index: 0
    },
    variantDetailsSlider: false,
    moreDetailsSlider: {
        show: false,
        productData: {},
        onSave: ()=>{},
        index: 0
    },
    syncImages: true,
    showSyncImagesModal: false,
    showSettings: false,
    variantSpec: []
};

export default function loaderReducer(state=initialState, action) {
    switch(action.type) {
        case SHOW_EDIT_VARIANT_SLIDER:
            return {
                ...state,
                showEditVariantSlider: action.payload
            }
        case SHOW_VARIANT_TYPE_SLIDER:
            return {
                ...state,
                variantTypeSlider: {
                    show: action.payload.show,
                    mode: action.payload.mode,
                    index: action.payload.index,
                    from: action.payload.from
                }
            };
        case SHOW_VARIANT_OPTIONS_SLIDER:
            return{
                ...state,
                variantOptionsSlider: {
                    show: action.payload.show,
                    index: action.payload.index,
                    mode: action.payload.mode,
                    keyType: action.payload.keyType
                }
            }
        case SHOW_VARIANT_DETAILS_SLIDER:
            return{
                ...state,
                variantDetailsSlider: action.payload
            }
        case SET_VARIANT_DATA:
            return{
                ...state,
                variantData: [...action.payload]
            }
        case SET_VARIANT_COMBINATIONS:
            return{
                ...state,
                variantCombinations: [...action.payload]
            }
        case SET_VARIANT_PRODUCT_DATA:
            return{
                ...state,
                variantProductData: [...action.payload]
            }
        case SET_VARIANT_CORRECTION: {
            return {
                ...state,
                variantCorrection: action.payload
            }
        }    
        case SHOW_MORE_DETAILS_SLIDER:
            return{
                ...state,
                moreDetailsSlider: {
                    show: action.payload.show,
                    productData: action.payload.productData,
                    allProductData: action.payload.allProductData,
                    onSave: action.payload.onSave,
                    index: action.payload.index,
                    titleStr: action.payload.titleStr
                }
            }
        case SET_SYNC_IMAGES:
            return{
                ...state,
                syncImages: action.payload
            }
        case SHOW_SYNC_IMAGES_MODAL:
            return{
                ...state,
                showSyncImagesModal: action.payload
            }
        case SHOW_SETTINGS_SLIDER:
            return{
                ...state,
                showSettings: action.payload
            }
        case UPDATE_VARIANT_SPEC:
            return{
                ...state,
                variantSpec: action.payload
            }
        case RESET_VARIANT_DATA:
            return {
                variantData: [],
                variantCombinations: [],
                variantProductData: [],
                variantCorrection: {},
                showEditVariantSlider: false,
                variantTypeSlider: {
                    show: false,
                    mode: 'add'
                },
                variantOptionsSlider: {
                    show: false,
                    index: 0
                },
                variantDetailsSlider: false,
                moreDetailsSlider: {
                    show: false,
                    productData: {},
                    onSave: ()=>{},
                    index: 0
                },
                syncImages: true,
                variantSpec : []
            }
        case SET_EDIT_VARIANT_DATA: 
            return{
                ...state,
                ...action.payload
            }
        default:
            return{
                ...state
            }
    }
}